<script lang="ts">
	import CountrySelector from '$lib/components/CountrySelector.svelte';
	import AnnouncementBar from '$lib/components/header/AnnouncementBar.svelte';

	import AuthButton from './buttons/AuthButton.svelte';
	import CartButton from './buttons/CartButton.svelte';
	import DesktopNavigation from './navigation/DesktopNavigation.svelte';
	import MobileNavigation from './navigation/MobileNavigation.svelte';
	import SearchBar from './SearchBar.svelte';

	const {
		menu,
		logo_url,
		name,
		announcement,
		siblings,
		currentCountry,
	}: {
		menu: Menu[];
		logo_url: string;
		name: string;
		announcement?: string;
		siblings: Config['siblings'];
		currentCountry: string;
	} = $props();
</script>

<header class="sticky top-0 z-20 bg-white pb-0">
	<AnnouncementBar {announcement} />
	<div class="full-container 2xl:mx-auto">
		<div class="flex h-15 items-center justify-between gap-4 px-1 sm:px-4 xl:h-20">
			<a href="/" class="h-full max-w-96 pl-2 xl:pl-0">
				<img class="h-full" src={logo_url} alt={name} />
			</a>

			<div class="hidden flex-1 justify-center p-4 xl:flex">
				<SearchBar class="w-7/12" inputClass="h-11 rounded-md border px-6" containerClass="pr-3" />
			</div>

			<div class="flex items-center justify-end gap-5 *:size-7 *:sm:size-8 md:gap-10 *:md:size-10">
				<CountrySelector {siblings} {currentCountry} class="hidden items-center xl:flex" />

				<AuthButton />

				<CartButton />
			</div>
		</div>

		<div>
			<div class="flex h-12 border-t border-b xl:hidden">
				<MobileNavigation {menu} {siblings} {currentCountry} />
				<div class="flex-1 border-l">
					<SearchBar class="h-full" inputClass="h-full p-3" containerClass="pr-6" />
				</div>
			</div>

			<div class="hidden px-4 xl:block">
				<DesktopNavigation {menu} />
			</div>
		</div>
	</div>
</header>
